import React, { PureComponent } from 'react';
import './styles.scss';

export default class FailedMessagesList extends PureComponent {
  render() {
    const arrMessages = this.props.messagesList || [];

    return (
      arrMessages &&
      !!arrMessages.length && (
        <div
          className={`${this.props.className} alert alert-danger alert-dismissible fade show`}
          role="alert"
        >
          {
            <ul>
              {arrMessages.map((err, ix) => (
                <li key={ix}>* {err.message}</li>
              ))}
            </ul>
          }
        </div>
      )
    );
  }
}
